import Slider from '../../components/slider';

const mainSlider = document.querySelector('.j-main-screen__slider');

if (mainSlider) {
    const slider = new Slider();

    slider.init({
        slider       : mainSlider,
        dots         : false,
        thumbnails   : false,
        caption      : true,
        arrow        : true,
        arrowPosition: 'allSlider',
        counter      : false,
        modify       : 'main-slider_slide',
        infinityLoop : true,
        customArrows : true,
        duration     : '0.75s',
        autoplay     : true,
        autoplaySpeed: 5000
    });
}

const offersSlider = document.querySelector('.j-main-offers__slider');

if (offersSlider) {
    const sliderLead = new Slider();

    sliderLead.init({
        slider       : offersSlider,
        dots         : false,
        thumbnails   : false,
        caption      : true,
        arrow        : true,
        arrowPosition: 'allSlider',
        counter      : false,
        infinityLoop : true,
        customArrows : true,
        duration     : '0.75s',
        autoplay     : true,
        autoplaySpeed: 17000
    });
}
